import styled from 'styled-components'
import { Layout,Card } from 'antd'
const { Content } = Layout

export const StyledMember = styled.div`
  .price-title{
    color: #6aa3f9;
    font-weight: 700;
    font-size: 120%!important;
  }
  label{
      font-weight: 700;
  }
  .month{
    color: #77a464;
  }
`

export const StyledStripeForm = styled.div`
    position: relative;
    z-index: 999;
    .ant-card-type-inner {
      padding-bottom: 35px;
    }
    .btn-con { 
        position: absolute;
        top: 254px;
        right: 0;
        width: 100%;
        margin-top: 30px;
    }
    
    .btn-credit{
        width:100%;
        border-radius: 4px 0px 0px 4px;
        border-right: 1px solid #1874e6;
    }
    
    .btn-paypal{
        width:100%;
        border-radius: 0px 4px 4px 0px;
    }
    
    .error{
        float: right;
        color: red;
    }
    .text-denger {
      color: red;
    ]
`

export const StyledContent = styled(Content) `
  margin: 24px 16px;
`

export const StyledPromocode = styled(Card)`

   
`

export const StyledShopCard = styled(Card)`
  .ant-card-body {
    max-width: 915px;
    margin: 20px auto;
  }

`

export const StyledOrderCard = styled(Card)`
  .ant-card-body {
      padding: 15px;
  }
  .line{
      border-bottom: 1px solid #ddd;
      padding: 15px;
  }
  .line-header{
      border-bottom: 1px solid #ddd;
      padding: 15px;
      font-weight: 700;
      background-color: #fafafa;
  }
`


// WEBPACK FOOTER //
// ./src/components/shop-pages/style.js